/**
 * AnalyticsBoundary — queues a sanitized GA4 page_view on every React Router
 * path change. Must be rendered INSIDE <BrowserRouter>.
 *
 * P1D: page-view tracking is now CHEAP — trackPageView() only pushes to the
 * window.dataLayer queue (no library). The heavy gtag.js (~190 KB) is loaded
 * deterministically post-critical (first interaction / window.load + delay /
 * pagehide) by lib/analytics.js, which replays the queued views in order.
 * So each route's view is captured the instant it renders (no idle race, no
 * lost/duplicate views), while Google's execution stays out of the startup /
 * TBT / interaction window. De-dupe + sensitive-route guards live in
 * analytics.js.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

export default function AnalyticsBoundary() {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}
